import { Component, OnInit } from '@angular/core';
import {BasicParametersComponent} from '../../basic-parameters/basic-parameters.component';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {AlertaService} from '../../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-chacon-sms-basic-parameters',
  templateUrl: './chacon-sms-basic-parameters.component.html',
  styleUrls: ['./chacon-sms-basic-parameters.component.scss']
})
export class ChaconSmsBasicParametersComponent extends BasicParametersComponent implements OnInit {

    constructor(protected fb: FormBuilder, protected portalCampFactory: PortalServiceFactoryService, protected alertHandler: AlertaService) {
        super(fb, portalCampFactory, alertHandler);

        this.form.setControl('line_chaconsms_account', new FormControl('', Validators.required));
    }

    ngOnInit(){
        super.ngOnInit();
        this.form.controls['line_chaconsms_account'].setValue(this.portalService.getConfigKey('line_chaconsms_account', ''));
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/chacon-sms/chacon-sms-basic-parameters/chacon-sms-basic-parameters.component.ts